(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kuulas-dermapen-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const button=event.target.closest('.kuulas-dermapen-video__play');
  if(!button)return;
  const video=button.parentElement.querySelector('video');
  video.play().then(function(){button.hidden=true;}).catch(function(){button.hidden=false;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuulas-isclinical-cover"] && !Shopify.designMode) return;
  try {
    
function initIsclinicalBanners(scope){
 scope.querySelectorAll('[data-isclinical-banner]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const slides=[...root.querySelectorAll('.kuulas-isclinical-banner__slide')],dots=[...root.querySelectorAll('[data-slide]')],pause=root.querySelector('[data-pause]');
  if(slides.length<2)return;
  const motion=matchMedia('(prefers-reduced-motion:reduce)'),mobile=matchMedia('(max-width:768px)');let index=0,paused=motion.matches,timer;
  const show=i=>{index=(i+slides.length)%slides.length;slides.forEach((s,j)=>s.hidden=j!==index);dots.forEach((d,j)=>d.setAttribute('aria-pressed',String(j===index)));};
  const loop=()=>{clearInterval(timer);if(!paused&&!document.hidden&&!mobile.matches)timer=setInterval(()=>show(index+1),7000);};
  const label=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?root.dataset.playLabel:root.dataset.pauseLabel);};
  dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);loop();}));
  root.querySelector('[data-prev]').addEventListener('click',()=>{show(index-1);loop();});
  root.querySelector('[data-next]').addEventListener('click',()=>{show(index+1);loop();});
  pause.addEventListener('click',()=>{paused=!paused;label();loop();});
  root.addEventListener('mouseenter',()=>clearInterval(timer));root.addEventListener('mouseleave',loop);
  root.addEventListener('focusin',()=>clearInterval(timer));root.addEventListener('focusout',loop);
  document.addEventListener('visibilitychange',loop);motion.addEventListener('change',()=>{paused=motion.matches;label();loop();});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))clearInterval(timer);});
  mobile.addEventListener('change',()=>{if(mobile.matches)show(0);loop();});
  if(mobile.matches)show(0);
  label();loop();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initIsclinicalBanners(document));else initIsclinicalBanners(document);
document.addEventListener('shopify:section:load',event=>initIsclinicalBanners(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuulas-isclinical"] && !Shopify.designMode) return;
  try {
    
  function initKuulasIsclinical(scope) {
    scope.querySelectorAll('[data-kuulas-isclinical]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const select = root.querySelector('[data-need]');
      const cards = [...root.querySelectorAll('[data-need-product]')].map(el => ({el, retinol: el.dataset.retinol === 'true', needs: [...new Set([...(JSON.parse(el.dataset.needs || 'null') || []), ...((el.dataset.curatedNeeds || '').split('|').filter(Boolean))])]}));
      const count = root.querySelector('[data-count]');
      const more = root.querySelector('[data-more]');
      let limit = 24;
      const update = () => {
        const matching = cards.filter(card => !select.value || (select.value === 'Retinol-tuotteet' ? card.retinol : card.needs.includes(select.value)));
        cards.forEach(card => {card.el.hidden = true;});
        matching.slice(0, limit).forEach(card => {card.el.hidden = false;});
        count.textContent = count.dataset.countText.replace('__COUNT__', matching.length);
        root.querySelector('[data-empty]').hidden = matching.length > 0;
        more.hidden = matching.length <= limit;
      };
      const restore = () => {
        const requested = new URL(location.href).searchParams.get('ihon_tarve') || '';
        select.value = [...select.options].some(option => option.value === requested) ? requested : '';
        limit = 24;
        update();
      };
      select.addEventListener('change', () => {
        limit = 24;
        const url = new URL(location.href);
        if(select.value) url.searchParams.set('ihon_tarve', select.value);
        else url.searchParams.delete('ihon_tarve');
        history.replaceState(null, '', url);
        update();
      });
      more.addEventListener('click', () => {limit += 24; update();});
      window.addEventListener('popstate', restore);
      restore();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initKuulasIsclinical(document));
  else initKuulasIsclinical(document);
  document.addEventListener('shopify:section:load', event => initKuulasIsclinical(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuulas-optiphi"] && !Shopify.designMode) return;
  try {
    
  function initKuulasOptiphi(scope) {
    scope.querySelectorAll('[data-kuulas-optiphi]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const select = root.querySelector('[data-need]');
      const cards = [...root.querySelectorAll('[data-need-product]')].map(el => ({el, retinol: el.dataset.retinol === 'true', needs: JSON.parse(el.dataset.needs || 'null') || []}));
      const count = root.querySelector('[data-count]');
      const more = root.querySelector('[data-more]');
      let limit = 24;
      const update = () => {
        const matching = cards.filter(card => !select.value || (select.value === 'Retinol-tuotteet' ? card.retinol : card.needs.includes(select.value)));
        cards.forEach(card => {card.el.hidden = true;});
        matching.slice(0, limit).forEach(card => {card.el.hidden = false;});
        count.textContent = count.dataset.countText.replace('__COUNT__', matching.length);
        root.querySelector('[data-empty]').hidden = matching.length > 0;
        more.hidden = matching.length <= limit;
      };
      const restore = () => {
        const requested = new URL(location.href).searchParams.get('ihon_tarve') || '';
        select.value = [...select.options].some(option => option.value === requested) ? requested : '';
        limit = 24;
        update();
      };
      select.addEventListener('change', () => {
        limit = 24;
        const url = new URL(location.href);
        if(select.value) url.searchParams.set('ihon_tarve', select.value);
        else url.searchParams.delete('ihon_tarve');
        history.replaceState(null, '', url);
        update();
      });
      more.addEventListener('click', () => {limit += 24; update();});
      window.addEventListener('popstate', restore);
      restore();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initKuulasOptiphi(document));
  else initKuulasOptiphi(document);
  document.addEventListener('shopify:section:load', event => initKuulasOptiphi(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuulas-treatment-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const button=event.target.closest('.kuulas-treatment-video__play');
  if(!button)return;
  const video=button.parentElement.querySelector('video');
  video.play().then(function(){button.hidden=true;}).catch(function(){button.hidden=false;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuulas-welcome-video"] && !Shopify.designMode) return;
  try {
    
function initKuulasWelcome(root){root.querySelectorAll('.kuulas-welcome').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const video=section.querySelector('video');video.muted=true;if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause()})}
initKuulasWelcome(document);document.addEventListener('shopify:section:load',event=>initKuulasWelcome(event.target));

  } catch(e) { console.error(e); }
})();
})();
